import { render, staticRenderFns } from "./PartnerContentCreate.vue?vue&type=template&id=38112989&"
import script from "./PartnerContentCreate.vue?vue&type=script&lang=js&"
export * from "./PartnerContentCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports